module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header filled full-block light"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 deal_page_container"
  }, [(_vm.canEditColumn('organization_name', _vm.organization.id)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.name),
      expression: "organization.name"
    }],
    ref: ('organization_name' + _vm.organization.id),
    staticClass: "form-control",
    domProps: {
      "value": (_vm.organization.name)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.updateOrganization(_vm.organization)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.name = $event.target.value
      }
    }
  }) : _c('div', {
    on: {
      "click": function($event) {
        _vm.editColumn('organization_name', _vm.organization.id)
      }
    }
  }, [(_vm.organization.name != '') ? _c('h4', {
    staticClass: "deal_page_info pointer"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" " + _vm._s(_vm.organization.name))]) : _c('h4', {
    staticClass: "deal_page_info pointer"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("『公司名目前為空』")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-danger primary-btn pull-right",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = true
      }
    }
  }, [_vm._v("刪除公司")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 deal_page_sidebar_content text-left"
  }, [(_vm.canEditColumn('organization_address', _vm.organization.id)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.address),
      expression: "organization.address"
    }],
    ref: ('organization_address' + _vm.organization.id),
    staticClass: "form-control",
    domProps: {
      "value": (_vm.organization.address)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.updateOrganization(_vm.organization)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.address = $event.target.value
      }
    }
  }) : _c('div', {
    on: {
      "click": function($event) {
        _vm.editColumn('organization_address', _vm.organization.id)
      }
    }
  }, [(_vm.organization.address != '') ? _c('p', {
    staticClass: "pointer margin0"
  }, [_vm._v("地址：" + _vm._s(_vm.organization.address) + " "), _c('i', {
    staticClass: "fa fa-pen"
  })]) : _c('p', {
    staticClass: "pointer margin0"
  }, [_vm._v("地址：空空的 "), _c('i', {
    staticClass: "fa fa-pen"
  })])]), _vm._v(" "), (_vm.canEditColumn('organization_phone', _vm.organization.id)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.phone),
      expression: "organization.phone"
    }],
    ref: ('organization_phone' + _vm.organization.id),
    staticClass: "form-control",
    domProps: {
      "value": (_vm.organization.phone)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.updateOrganization(_vm.organization)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.phone = $event.target.value
      }
    }
  }) : _c('div', {
    on: {
      "click": function($event) {
        _vm.editColumn('organization_phone', _vm.organization.id)
      }
    }
  }, [(_vm.organization.phone != '') ? _c('p', {
    staticClass: "pointer margin0"
  }, [_vm._v("市話：" + _vm._s(_vm.organization.phone) + " "), _c('i', {
    staticClass: "fa fa-pen"
  })]) : _c('p', {
    staticClass: "pointer margin0"
  }, [_vm._v("市話：空空的 "), _c('i', {
    staticClass: "fa fa-pen"
  })])]), _vm._v(" "), (_vm.canEditColumn('organization_number', _vm.organization.id)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.number),
      expression: "organization.number"
    }],
    ref: ('organization_number' + _vm.organization.id),
    staticClass: "form-control",
    domProps: {
      "value": (_vm.organization.number)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.updateOrganization(_vm.organization)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.number = $event.target.value
      }
    }
  }) : _c('div', {
    on: {
      "click": function($event) {
        _vm.editColumn('organization_number', _vm.organization.id)
      }
    }
  }, [(_vm.organization.number != '') ? _c('p', {
    staticClass: "pointer margin0"
  }, [_vm._v("統一編號：" + _vm._s(_vm.organization.number) + " "), _c('i', {
    staticClass: "fa fa-pen"
  })]) : _c('p', {
    staticClass: "pointer margin0"
  }, [_vm._v("統一編號：空空的 "), _c('i', {
    staticClass: "fa fa-pen"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 deal_page_sidebar_content  text-left"
  }, [(_vm.contacts.length == 0) ? _c('p', {
    staticClass: "pointer"
  }, [_vm._v("\n                            目前皆無聯絡人\n                          ")]) : _vm._l((_vm.contacts), function(contact) {
    return _c('p', {
      staticClass: "text-gray"
    }, [_c('i', {
      staticClass: "fa fa-search pointer text-primary",
      on: {
        "click": function($event) {
          _vm.ShowContact(contact.contact_token)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "pointer bold text-primary",
      on: {
        "click": function($event) {
          _vm.ShowContact(contact.contact_token)
        }
      }
    }, [_vm._v(_vm._s(contact.name))]), _vm._v(" " + _vm._s(contact.email) + " " + _vm._s(contact.phone) + "\n                          ")])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 deal_page_sidebar_content  text-left"
  }, _vm._l((_vm.recent_deals), function(deal) {
    return _c('div', {
      staticClass: "media",
      on: {
        "click": function($event) {
          _vm.ShowDeal(deal.deal_token)
        }
      }
    }, [_c('div', {
      staticClass: "medai-body"
    }, [_c('p', {
      staticClass: "pointer pr-3"
    }, [_vm._v("\n\t\t                          \t" + _vm._s(deal.title) + " -  $" + _vm._s(deal.value.toLocaleString()) + " \n\t\t                          ")])]), _vm._v(" "), (deal.status == 'won') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已簽約")]) : _vm._e(), _vm._v(" "), (deal.status == 'lost') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("已丟失")]) : _vm._e(), _vm._v(" "), (deal.status == 'open') ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("進行中")]) : _vm._e()])
  }))]), _vm._v(" "), (_vm.recent_deals == '') ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "text-center"
  }, [_vm._v("目前尚無交易")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "new_note"
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('label', {
    attrs: {
      "for": "textarea"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.activity_content),
      expression: "activity_content"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.activity_content),
      expression: "activity_content"
    }],
    staticClass: "bootstrap_textarea",
    attrs: {
      "rows": "3",
      "placeholder": "新增註記內容"
    },
    domProps: {
      "value": (_vm.activity_content)
    },
    on: {
      "keydown": function($event) {
        _vm.content_type = 'note'
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activity_content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "form-footer j-forms"
  }, [_c('button', {
    staticClass: "btn btn-info primary-btn",
    on: {
      "click": _vm.add_activity
    }
  }, [_vm._v("新增")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "new_file"
    }
  }, [_c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.axios.defaults.baseURL + '/activities/add_activity',
      "headers": _vm.auth_token
    },
    on: {
      "vdropzone-success": _vm.file_uploaded
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "organization_token"
    },
    domProps: {
      "value": this.$route.params.organization_token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "activity_type",
      "value": "organization"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "content_type",
      "value": "attachment"
    }
  })])], 1)])])])])]), _vm._v(" "), _c('history', {
    attrs: {
      "activities": _vm.organization_activities,
      "activity_categories": _vm.activity_categories
    }
  })], 1)])])])]), _vm._v(" "), _c('DeleteModal', {
    attrs: {
      "AuthToken": _vm.auth_token,
      "TargetToken": this.$route.params.organization_token,
      "target": 'organizations'
    },
    model: {
      value: (_vm.showDeleteModal),
      callback: function($$v) {
        _vm.showDeleteModal = $$v
      },
      expression: "showDeleteModal"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("公司資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("聯絡人")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("近期交易")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs nav-center",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#new_note",
      "aria-controls": "new_note",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("新增註記")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#new_file",
      "aria-controls": "new_file",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("上傳檔案")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3474cca4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organizations/Organization.vue
// module id = 683
// module chunks = 4